module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "accordionChevron.9d5afc18.svg";